import { ChangeDetectionStrategy, Component, DestroyRef, OnInit } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ReactiveFormsModule } from "@angular/forms";
import { isEmptyString } from "@ankaadia/ankaadia-shared";
import { FieldType, FormlyModule } from "@ngx-formly/core";
import { isNil } from "lodash";
import { Message } from "primeng/message";
import { filter } from "rxjs";
import { NewUiInputnumberComponent } from "../../shared/form/inputnumber/new-ui-inputnumber.component";
import { NewUiInputtextComponent } from "../../shared/form/inputtext/new-ui-inputtext.component";
import { NewUiFormElementMapModule } from "../../shared/from-element-map/new-ui-form-element-map.module";
import { valuesOf } from "../../shared/services/form.helper";
import { TestIdDirective } from "../../shared/test-id/test-id.directive";

@Component({
  selector: "new-ui-formly-input",
  templateUrl: "./new-ui-formly-input.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    FormlyModule,
    NewUiFormElementMapModule,
    TestIdDirective,
    Message,
    NewUiInputnumberComponent,
    NewUiInputtextComponent,
  ],
})
export class NewUiFormlyInputComponent extends FieldType implements OnInit {
  constructor(private readonly destroyRef: DestroyRef) {
    super();
  }

  ngOnInit(): void {
    if (this.field?.props?.emptyToNull && this.field.formControl) {
      valuesOf(this.field.formControl)
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          filter((x) => !isNil(x) && isEmptyString(x))
        )
        .subscribe(() => this.field.formControl.setValue(null, { emitEvent: false }));
    }
  }
}
